import { useEffect, useRef } from 'react';
import { debounce } from 'lodash-es';
import { trackVWOCustomConversionById } from 'lib/analytics/vwo';

export const useVWOCustomConversionTracking = (currentTime, videoDuration) => {
  const trackConversion = useRef(
    debounce(id => {
      trackVWOCustomConversionById(id);
    }, 500)
  ).current;

  useEffect(() => {
    if (currentTime === 15) {
      trackConversion(203);
    }
    if (currentTime === Math.floor(videoDuration * 0.25)) {
      trackConversion(204);
    }
  }, [currentTime, videoDuration, trackConversion]);
};
